module.exports = __webpack_public_path__ + "static/media/office-desk-mobile.27aff99e.jpg";